import { render } from "./TestStartView.vue?vue&type=template&id=a1773b64&scoped=true&lang=true"
import script from "./TestStartView.vue?vue&type=script&lang=js"
export * from "./TestStartView.vue?vue&type=script&lang=js"

import "./TestStartView.vue?vue&type=style&index=0&id=a1773b64&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.26_vue@3.5.26_webpack@5.104.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a1773b64"]])

export default __exports__